import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { Dialog } from '@app/components/shared/dialog/dialog';
import { Button } from '@app/components/shared/button/button';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { HeaterPendingAudit } from '@app/models/heaters';

@Component({
  selector: 'app-modal-deny-audit-pending',
  imports: [Dialog, Button, ReactiveFormsModule],
  templateUrl: './modal-deny.html',
  styleUrl: './modal-deny.css',
})
export class ModalDeny {
  private readonly FormBuilder = inject(FormBuilder);
  form!: FormGroup;

  @Input() selection: HeaterPendingAudit[] = [];
  @Output() onCancel = new EventEmitter<void>();
  @Output() onConfirm = new EventEmitter<string>();

  private buildForm() {
    this.form = this.FormBuilder.group({
      observations: [
        '',
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(500),
        ],
      ],
    });
  }

  constructor() {
    this.buildForm();
  }

  get observationsControl(): FormControl {
    return this.form.get('observations') as FormControl;
  }

  handleCancel() {
    this.onCancel.emit();
  }

  handleConfirm() {
    this.form.markAllAsTouched();
    if (this.form.valid) {
      this.onConfirm.emit(this.observationsControl.value);
    }
  }

  getSerials(): string {
    return this.selection.map((item) => item.serial).join(', ');
  }
}
